import React from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { TopBarContainer } from "../top-bar-container"
import BackIcon from "@/assets/icons/misc/back-icon.tsx"
import CircleTickIcon from "@/assets/icons/task/circle-tick-icon.tsx"
import styles from "@/components/top-bars/top-bars-common.module.css"
import { useMediaQuery } from "@/hooks/use-media-query.ts"

interface EditorTopBarProps {
  text: string
  onSave?: () => void
  isModified: boolean
  onBackClick?: () => void
}

const EditorTopBar: React.FC<EditorTopBarProps> = ({
  text,
  onSave,
  isModified = true,
  onBackClick,
}) => {
  const { t } = useTranslation()
  const isDesktop = useMediaQuery("(min-width: 768px)")
  const navigate = useNavigate()

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick()
    } else {
      navigate(-1)
    }
  }

  if (isDesktop) return null

  return (
    <TopBarContainer>
      <div className={"flex items-center"}>
        <div
          className={
            "grid place-content-center p-4 md:scale-75 md:cursor-pointer"
          }
          onClick={handleBackClick}
        >
          <BackIcon />
        </div>
        <div className="overflow-hidden truncate whitespace-nowrap text-body-md font-semibold leading-[30px] text-[var(--dark-grey)]">
          {t(text)}
        </div>
      </div>
      <div className={styles.floatRight}>
        {isModified && (
          <div
            role="button"
            className={styles.actionIcon}
            onClick={() => {
              onSave?.()
            }}
          >
            <CircleTickIcon alt="save" size={30} />
            <span className={"sr-only"}>Save animal</span>
          </div>
        )}
      </div>
    </TopBarContainer>
  )
}

export default EditorTopBar
